<app-ds-typography 
  [fontFamily]="fontFamily.Regular" 
  [color]="fontColor.Primary"
  [size]="fontSize.XXS" 
  [text]="rateDescription">
</app-ds-typography>